export class OrganisationView {
    public organisationId: string;
    public iataNumber: string;
    public organisationName: string;
}